import { createApi } from "@reduxjs/toolkit/query/react";

import supplierBaseQuery from "./supplierBaseQuery";

export const SUPPLIERS_API_REDUCER_KEY = "suppliersApi";

export const suppliersApi = createApi({
  reducerPath: SUPPLIERS_API_REDUCER_KEY,
  baseQuery: supplierBaseQuery,
  tagTypes: ["supplier"],
  endpoints: (builder) => ({
    getSignUpDetails: builder.query({
      query: (token) => ({
        url: `/users/invites/uuid/${token}/`,
      }),
      providesTags: ["auth"],
    }),
    getUserSuppliers: builder.query({
      query: () => ({
        url: "/users/suppliers/",
      }),
      providesTags: ["supplier"],
    }),

    getSupplierTenants: builder.query({
      query: ({ supplier_id }) => ({
        url: `/suppliers/${supplier_id}/tenants/`,
      }),
      providesTags: ["supplier"],
    }),

    updateSupplierInvite: builder.mutation({
      query: ({ id, ...rest }) => {
        return {
          url: `users/invites/${id}`,
          method: "PUT",
          body: rest,
        };
      },
      invalidatesTags: ["supplier"],
    }),
    getSupplierInvites: builder.query({
      query: ({ supplier_id }) => {
        if (!supplier_id) {
          return;
        }
        return {
          url: `/suppliers/${supplier_id}/invites/`,
        };
      },
      providesTags: ["supplier"],
    }),
    getMe: builder.query({
      query: () => ({
        url: `users/me/`,
      }),
      providesTags: ["supplier"],
    }),
    getSupplierProfile: builder.query({
      query: (supplier_id) => {
        if (!supplier_id) {
          return;
        }
        return {
          url: `/suppliers/${supplier_id}`,
        };
      },
      providesTags: ["supplier"],
    }),
    updateProfile: builder.mutation({
      query: ({ supplier_id, body }) => {
        return {
          url: `/suppliers/${supplier_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["supplier"],
    }),
    updateInvite: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/users/invites/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["supplier"],
    }),
    updateSupplierLogo: builder.mutation({
      query: ({ supplier_id, body }) => {
        return {
          url: `/suppliers/${supplier_id}/logo`,
          method: "PUT",
          body: body,
        };
      },
      invalidatesTags: ["supplier"],
    }),
    generateLoginToken: builder.mutation({
      query: ({ supplier_id, body, tenant_id }) => {
        return {
          url: `/suppliers/${supplier_id}/tenants/${tenant_id}/login-token`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["supplier"],
    }),
  }),
});

export const {
  useGetUserSuppliersQuery,
  useUpdateSupplierInviteMutation,
  useGetSupplierTenantsQuery,
  useGetSignUpDetailsQuery,
  useGetMeQuery,
  useLazyGetMeQuery,
  useUpdateProfileMutation,
  useGetSupplierProfileQuery,
  useUpdateSupplierLogoMutation,
  useGetSupplierInvitesQuery,
  useUpdateInviteMutation,
  useGenerateLoginTokenMutation,
} = suppliersApi;
